import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  LanguageTypeForm,
  LanguageValue,
  languageTypeData,
} from 'util/ConstantValues';
import useOutsideClick from 'util/hooks/useClickOutside';
import IconDown from '../icons/IconDown';
import { IconLanguage } from '../icons/IconLanguage';
import './LanguageSelect.scss';
import { mergeClasses } from 'util/commons';

type LanguageSelectProps = {
  classNames?: {
    wrapper?: string;
    dropdown?: string;
  };
};

const LanguageSelect: React.FC<LanguageSelectProps> = ({ classNames }) => {
  const { i18n } = useTranslation();
  const { ref } = useOutsideClick({
    onClickOutside: () => {
      setDropdownOpened(false);
    },
  });

  const langLocalStorage = useMemo(
    () => localStorage.getItem('i18nextLng') as LanguageValue,
    []
  );

  const [selectLanguage, setSelectLanguage] = useState<LanguageTypeForm>({
    language: LanguageValue.Japanese,
  });

  const [dropdownOpened, setDropdownOpened] = useState<boolean>(false);

  useEffect(() => {
    if (langLocalStorage) {
      setSelectLanguage({ language: langLocalStorage });
    } else {
      i18n.changeLanguage(LanguageValue.Japanese);
    }
  }, []);

  const onChangeLanguage = (lang: LanguageValue) => {
    i18n.changeLanguage(lang);
    setSelectLanguage({ language: lang });
    setDropdownOpened(false);
  };

  const onSelectLanguage = () => setDropdownOpened(!dropdownOpened);

  return (
    <>
      <div
        className={mergeClasses('languages', classNames?.wrapper)}
        onClick={onSelectLanguage}
      >
        <div className="icon-language">
          <IconLanguage />
        </div>
        <div className="text">Language</div>
        <div className="icon-down">
          <IconDown size="20" />
        </div>
      </div>
      {dropdownOpened && (
        <div
          className={mergeClasses('dropdown-content', classNames?.dropdown)}
          ref={ref}
        >
          {languageTypeData.map((lang) => (
            <div
              className={mergeClasses('dropdown-item', {
                selected: selectLanguage.language === lang.value,
              })}
              key={lang.value}
              onClick={() => onChangeLanguage(lang.value)}
            >
              {lang.label}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default LanguageSelect;
